// Prefer explicit env var (useful for local dev). Otherwise use the frontend origin
const DEFAULT_BASE = typeof window !== 'undefined' && window.location ? window.location.origin : 'http://localhost';
var BASE_URL = process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE;

//This if applies when running FE locally and not in docker
if(DEFAULT_BASE === 'http://localhost:3000' ){BASE_URL = 'http://localhost';}

const API_ENDPOINTS = {
  // Note: app.py exposes some endpoints at root (e.g. /login, /logout, /check-auth)
  // and internal APIs under /api/. With nginx proxy sending these root paths
  // to the backend, using the same origin here makes requests route through
  // the frontend host (e.g. http://yourdomain) and be proxied by nginx.
  LOGIN: `${BASE_URL}/api/login`,
  LOGOUT: `${BASE_URL}/api/logout`,
  CHECK_AUTH: `${BASE_URL}/api/check-auth`,
  FETCH_MODULES: `${BASE_URL}/modules`,
  PRIVACY_ACCEPT: `${BASE_URL}/api/privacy/accept`,
  BASEURL: `${BASE_URL}`,
  // Feedback
  EMPLOYEES: `${BASE_URL}/api/employees`,
  FEEDBACK_SUBMIT: `${BASE_URL}/api/feedback`,
  FEEDBACK_RECEIVED: `${BASE_URL}/api/feedback/received`,
  FEEDBACK_GIVEN: `${BASE_URL}/api/feedback/given`,
  FEEDBACK_ADMIN_ALL: `${BASE_URL}/api/admin/feedback/all`,
  // Branches
  BRANCHES: `${BASE_URL}/api/branches`,
  BRANCH_CREATE: `${BASE_URL}/api/branches`,
  BRANCH_UPDATE: (branchId) => `${BASE_URL}/api/branches/${branchId}`,
  BRANCH_DELETE: (branchId) => `${BASE_URL}/api/branches/${branchId}`,
  BRANCH_USER_COUNT: (branchId) => `${BASE_URL}/api/branches/${branchId}/user-count`,
  ADD_USER_BRANCH: (email) => `${BASE_URL}/api/users/${email}/branches`,
  REMOVE_USER_BRANCH: (email, branchId) => `${BASE_URL}/api/users/${email}/branches/${branchId}`,
  UPDATE_USER: (email) => `${BASE_URL}/api/users/${email}`,
  // Schedules
  SCHEDULE_GET: (email) => `${BASE_URL}/api/schedules/${email}`,
  SCHEDULE_SAVE: (email) => `${BASE_URL}/api/schedules/${email}`,
  SCHEDULE_DELETE: (email) => `${BASE_URL}/api/schedules/${email}`,
  SCHEDULE_EFFECTIVE: (email) => `${BASE_URL}/api/schedules/${email}/effective`,
  SCHEDULE_WEEKLY_GET: (email) => `${BASE_URL}/api/schedules/${email}/weekly`,
  SCHEDULE_WEEKLY_SAVE: (email) => `${BASE_URL}/api/schedules/${email}/weekly`,
  SCHEDULE_WEEKLY_DELETE: (email) => `${BASE_URL}/api/schedules/${email}/weekly`,
  SCHEDULE_MONTHLY: (email) => `${BASE_URL}/api/schedules/${email}/monthly`,
  SCHEDULE_COPY: (email) => `${BASE_URL}/api/schedules/${email}/copy`,
  // Timecards
  TIMECARD_GET: (email) => `${BASE_URL}/api/timecards/${email}`,
  TIMECARD_LIST: (email) => `${BASE_URL}/api/timecards/list/${email}`,
  TIMECARD_SAVE: `${BASE_URL}/api/timecards`,
  TIMECARD_SUBMIT: (email, weekStart) => `${BASE_URL}/api/timecards/${email}/${weekStart}/submit`,
  TIMECARD_APPROVE: (email, weekStart) => `${BASE_URL}/api/timecards/${email}/${weekStart}/approve`,
  TIMECARD_REJECT: (email, weekStart) => `${BASE_URL}/api/timecards/${email}/${weekStart}/reject`,
  TIMECARD_PENDING: `${BASE_URL}/api/timecards/pending`,
  TIMECARD_HISTORY: `${BASE_URL}/api/timecards/history`,
  // Vacations
  VACATION_SUBMIT: `${BASE_URL}/api/vacations`,
  VACATION_GET: (email) => `${BASE_URL}/api/vacations/${email}`,
  VACATION_PENDING: `${BASE_URL}/api/vacations/pending`,
  VACATION_HISTORY: `${BASE_URL}/api/vacations/history`,
  VACATION_APPROVE: (id) => `${BASE_URL}/api/vacations/${id}/approve`,
  VACATION_REJECT: (id) => `${BASE_URL}/api/vacations/${id}/reject`,
  // Reports
  REPORTS_SUBMIT: `${BASE_URL}/api/reports`,
  REPORTS_LIST: `${BASE_URL}/api/reports`,
  REPORTS_DELETE: (id) => `${BASE_URL}/api/reports/${id}`,
  REPORTS_UPDATE_STATUS: (id) => `${BASE_URL}/api/reports/${id}/status`,
  // Learning Modules
  LEARNING_MODULES: `${BASE_URL}/api/learning_modules`,
  LEARNING_MODULES_USER: `${BASE_URL}/api/user/learning_modules`,
  LEARNING_MODULES_PROGRESS: `${BASE_URL}/api/user/learning_modules/progress`,
  LEARNING_MODULES_ADMIN_PROGRESS: `${BASE_URL}/api/admin/learning_modules/progress`,
  LEARNING_MODULE_SHARED_SAS: (videoid) => `${BASE_URL}/api/learning-module/sas/${videoid}`,
  LEARNING_MODULE_CHECK_ANSWER: (videoid) => `${BASE_URL}/api/learning_modules/${videoid}/check_answer`,
  LEARNING_MODULE_SUBMIT_QUIZ: (videoid) => `${BASE_URL}/api/learning_modules/${videoid}/submit_quiz`,
  LEARNING_MODULES_CUSTOM: `${BASE_URL}/api/learning-modules/custom`,
  LEARNING_MODULES_CUSTOM_DETAIL: (videoid) => `${BASE_URL}/api/learning-modules/custom/${videoid}`,
  LEARNING_MODULES_CLIENT_SAS_UPLOAD: (mediaType) => `${BASE_URL}/api/learning-modules/client-sas/upload/${mediaType}`,
  LEARNING_MODULES_CLIENT_SAS_FETCH: (videoid) => `${BASE_URL}/api/learning-modules/client-sas/fetch/${videoid}`,
  LEARNING_MODULES_CLIENT_SAS_THUMBNAIL: (videoid) => `${BASE_URL}/api/learning-modules/client-sas/thumbnail-sas/${videoid}`,
  LEARNING_MODULES_ALL: `${BASE_URL}/api/learning-modules/custom/all`,
  LEARNING_MODULES_ALL_META: `${BASE_URL}/api/learning-modules/custom/all/meta`,
  LEARNING_MODULE_SET_DEFAULT: (videoid) => `${BASE_URL}/api/learning-modules/${videoid}/default`,
  HIREE_LEARNING_MODULES: (email) => `${BASE_URL}/api/hirees/${email}/learning_modules`,
  TRAINING_COMPLIANCE_SUMMARY: `${BASE_URL}/api/training-compliance/summary`,
  TRAINING_COMPLIANCE_REMINDERS: `${BASE_URL}/api/training-compliance/reminders`,
  // Vacancies & Prospects
  VACANCIES: `${BASE_URL}/api/vacancies`,
  VACANCY_SUGGEST_KEYWORDS: `${BASE_URL}/api/vacancies/suggest-keywords`,
  VACANCY_DETAIL: (id) => `${BASE_URL}/api/vacancies/${id}`,
  VACANCY_PROSPECTS: (id) => `${BASE_URL}/api/vacancies/${id}/prospects`,
  PROSPECT_PROMOTE: (id) => `${BASE_URL}/api/prospects/${id}/promote`,
  PROSPECT_STATUS: (id) => `${BASE_URL}/api/prospects/${id}/status`,
  PROSPECT_RESUME: (id) => `${BASE_URL}/api/prospects/${id}/resume`,
  APPLY_GET: (token) => `${BASE_URL}/api/apply/${token}`,
  APPLY_SUBMIT: (token) => `${BASE_URL}/api/apply/${token}`,
  POSITIONS: `${BASE_URL}/api/positions`,
  // Subscription
  SUBSCRIPTION_STATUS: `${BASE_URL}/api/subscription/status`,
  SUBSCRIPTION_CHECKOUT: `${BASE_URL}/api/subscription/checkout`,
  SUBSCRIPTION_PORTAL: `${BASE_URL}/api/subscription/portal`,
};

export default API_ENDPOINTS;